const Countries = [
  {
    name: "Afghanistan",
    code: "AF",
    dialCode: "+93",
    flag: "https://flagcdn.com/af.svg",
  },
  {
    name: "Albania",
    code: "AL",
    dialCode: "+355",
    flag: "https://flagcdn.com/al.svg",
  },
  {
    name: "Algeria",
    code: "DZ",
    dialCode: "+213",
    flag: "https://flagcdn.com/dz.svg",
  },
  {
    name: "Andorra",
    code: "AD",
    dialCode: "+376",
    flag: "https://flagcdn.com/ad.svg",
  },
  {
    name: "Angola",
    code: "AO",
    dialCode: "+244",
    flag: "https://flagcdn.com/ao.svg",
  },
  {
    name: "Anguilla",
    code: "AI",
    dialCode: "+1-264",
    flag: "https://flagcdn.com/ai.svg",
  },
  {
    name: "Antigua and Barbuda",
    code: "AG",
    dialCode: "+1-268",
    flag: "https://flagcdn.com/ag.svg",
  },
  {
    name: "American Samoa",
    code: "AS",
    dialCode: "+1-684",
    flag: "https://flagcdn.com/as.svg",
  },
  {
    name: "Argentina",
    code: "AR",
    dialCode: "+54",
    flag: "https://flagcdn.com/ar.svg",
  },
  {
    name: "Armenia",
    code: "AM",
    dialCode: "+374",
    flag: "https://flagcdn.com/am.svg",
  },
  {
    name: "Aruba",
    code: "AW",
    dialCode: "+297",
    flag: "https://flagcdn.com/aw.svg",
  },
  {
    name: "Australia",
    code: "AU",
    dialCode: "+61",
    flag: "https://flagcdn.com/au.svg",
  },
  {
    name: "Austria",
    code: "AT",
    dialCode: "+43",
    flag: "https://flagcdn.com/at.svg",
  },
  {
    name: "Azerbaijan",
    code: "AZ",
    dialCode: "+994",
    flag: "https://flagcdn.com/az.svg",
  },
  {
    name: "Bahamas",
    code: "BS",
    dialCode: "+1-242",
    flag: "https://flagcdn.com/bs.svg",
  },
  {
    name: "Bahrain",
    code: "BH",
    dialCode: "+973",
    flag: "https://flagcdn.com/bh.svg",
  },
  {
    name: "Bangladesh",
    code: "BD",
    dialCode: "+880",
    flag: "https://flagcdn.com/bd.svg",
  },
  {
    name: "Barbados",
    code: "BB",
    dialCode: "+1-246",
    flag: "https://flagcdn.com/bb.svg",
  },
  {
    name: "Belarus",
    code: "BY",
    dialCode: "+375",
    flag: "https://flagcdn.com/by.svg",
  },
  {
    name: "Belgium",
    code: "BE",
    dialCode: "+32",
    flag: "https://flagcdn.com/be.svg",
  },
  {
    name: "Belize",
    code: "BZ",
    dialCode: "+501",
    flag: "https://flagcdn.com/bz.svg",
  },
  {
    name: "Benin",
    code: "BJ",
    dialCode: "+229",
    flag: "https://flagcdn.com/bj.svg",
  },
  {
    name: "Bhutan",
    code: "BT",
    dialCode: "+975",
    flag: "https://flagcdn.com/bt.svg",
  },
  {
    name: "Bolivia",
    code: "BO",
    dialCode: "+591",
    flag: "https://flagcdn.com/bo.svg",
  },
  {
    name: "Bosnia and Herzegovina",
    code: "BA",
    dialCode: "+387",
    flag: "https://flagcdn.com/ba.svg",
  },
  {
    name: "Botswana",
    code: "BW",
    dialCode: "+267",
    flag: "https://flagcdn.com/bw.svg",
  },
  {
    name: "Brazil",
    code: "BR",
    dialCode: "+55",
    flag: "https://flagcdn.com/br.svg",
  },
  {
    name: "Brunei",
    code: "BN",
    dialCode: "+673",
    flag: "https://flagcdn.com/bn.svg",
  },
  {
    name: "Bulgaria",
    code: "BG",
    dialCode: "+359",
    flag: "https://flagcdn.com/bg.svg",
  },
  {
    name: "Burkina Faso",
    code: "BF",
    dialCode: "+226",
    flag: "https://flagcdn.com/bf.svg",
  },
  {
    name: "Burundi",
    code: "BI",
    dialCode: "+257",
    flag: "https://flagcdn.com/bi.svg",
  },
  {
    name: "Cabo Verde",
    code: "CV",
    dialCode: "+238",
    flag: "https://flagcdn.com/cv.svg",
  },
  {
    name: "Cambodia",
    code: "KH",
    dialCode: "+855",
    flag: "https://flagcdn.com/kh.svg",
  },
  {
    name: "Cameroon",
    code: "CM",
    dialCode: "+237",
    flag: "https://flagcdn.com/cm.svg",
  },
  {
    name: "Canada",
    code: "CA",
    dialCode: "+1",
    flag: "https://flagcdn.com/ca.svg",
  },
  {
    name: "Central African Republic",
    code: "CF",
    dialCode: "+236",
    flag: "https://flagcdn.com/cf.svg",
  },
  {
    name: "Chad",
    code: "TD",
    dialCode: "+235",
    flag: "https://flagcdn.com/td.svg",
  },
  {
    name: "Chile",
    code: "CL",
    dialCode: "+56",
    flag: "https://flagcdn.com/cl.svg",
  },
  {
    name: "China",
    code: "CN",
    dialCode: "+86",
    flag: "https://flagcdn.com/cn.svg",
  },
  {
    name: "Colombia",
    code: "CO",
    dialCode: "+57",
    flag: "https://flagcdn.com/co.svg",
  },
  {
    name: "Comoros",
    code: "KM",
    dialCode: "+269",
    flag: "https://flagcdn.com/km.svg",
  },
  {
    name: "Congo (Congo-Brazzaville)",
    code: "CG",
    dialCode: "+242",
    flag: "https://flagcdn.com/cg.svg",
  },
  {
    name: "Congo (DRC)",
    code: "CD",
    dialCode: "+243",
    flag: "https://flagcdn.com/cd.svg",
  },
  {
    name: "Costa Rica",
    code: "CR",
    dialCode: "+506",
    flag: "https://flagcdn.com/cr.svg",
  },
  {
    name: "Croatia",
    code: "HR",
    dialCode: "+385",
    flag: "https://flagcdn.com/hr.svg",
  },
  {
    name: "Cuba",
    code: "CU",
    dialCode: "+53",
    flag: "https://flagcdn.com/cu.svg",
  },
  {
    name: "Cyprus",
    code: "CY",
    dialCode: "+357",
    flag: "https://flagcdn.com/cy.svg",
  },
  {
    name: "Czechia",
    code: "CZ",
    dialCode: "+420",
    flag: "https://flagcdn.com/cz.svg",
  },
  {
    name: "Denmark",
    code: "DK",
    dialCode: "+45",
    flag: "https://flagcdn.com/dk.svg",
  },
  {
    name: "Djibouti",
    code: "DJ",
    dialCode: "+253",
    flag: "https://flagcdn.com/dj.svg",
  },
  {
    name: "Dominica",
    code: "DM",
    dialCode: "+1-767",
    flag: "https://flagcdn.com/dm.svg",
  },
  {
    name: "Dominican Republic",
    code: "DO",
    dialCode: "+1-809",
    flag: "https://flagcdn.com/do.svg",
  },
  {
    name: "Ecuador",
    code: "EC",
    dialCode: "+593",
    flag: "https://flagcdn.com/ec.svg",
  },
  {
    name: "Egypt",
    code: "EG",
    dialCode: "+20",
    flag: "https://flagcdn.com/eg.svg",
  },
  {
    name: "El Salvador",
    code: "SV",
    dialCode: "+503",
    flag: "https://flagcdn.com/sv.svg",
  },
  {
    name: "Equatorial Guinea",
    code: "GQ",
    dialCode: "+240",
    flag: "https://flagcdn.com/gq.svg",
  },
  {
    name: "Eritrea",
    code: "ER",
    dialCode: "+291",
    flag: "https://flagcdn.com/er.svg",
  },
  {
    name: "Estonia",
    code: "EE",
    dialCode: "+372",
    flag: "https://flagcdn.com/ee.svg",
  },
  {
    name: "Eswatini",
    code: "SZ",
    dialCode: "+268",
    flag: "https://flagcdn.com/sz.svg",
  },
  {
    name: "Ethiopia",
    code: "ET",
    dialCode: "+251",
    flag: "https://flagcdn.com/et.svg",
  },
  {
    name: "Fiji",
    code: "FJ",
    dialCode: "+679",
    flag: "https://flagcdn.com/fj.svg",
  },
  {
    name: "Finland",
    code: "FI",
    dialCode: "+358",
    flag: "https://flagcdn.com/fi.svg",
  },
  {
    name: "France",
    code: "FR",
    dialCode: "+33",
    flag: "https://flagcdn.com/fr.svg",
  },
  {
    name: "Gabon",
    code: "GA",
    dialCode: "+241",
    flag: "https://flagcdn.com/ga.svg",
  },
  {
    name: "Gambia",
    code: "GM",
    dialCode: "+220",
    flag: "https://flagcdn.com/gm.svg",
  },
  {
    name: "Georgia",
    code: "GE",
    dialCode: "+995",
    flag: "https://flagcdn.com/ge.svg",
  },
  {
    name: "Germany",
    code: "DE",
    dialCode: "+49",
    flag: "https://flagcdn.com/de.svg",
  },
  {
    name: "Ghana",
    code: "GH",
    dialCode: "+233",
    flag: "https://flagcdn.com/gh.svg",
  },
  {
    name: "Greece",
    code: "GR",
    dialCode: "+30",
    flag: "https://flagcdn.com/gr.svg",
  },
  {
    name: "Grenada",
    code: "GD",
    dialCode: "+1-473",
    flag: "https://flagcdn.com/gd.svg",
  },
  {
    name: "Guatemala",
    code: "GT",
    dialCode: "+502",
    flag: "https://flagcdn.com/gt.svg",
  },
  {
    name: "Guinea",
    code: "GN",
    dialCode: "+224",
    flag: "https://flagcdn.com/gn.svg",
  },
  {
    name: "Guinea-Bissau",
    code: "GW",
    dialCode: "+245",
    flag: "https://flagcdn.com/gw.svg",
  },
  {
    name: "Guyana",
    code: "GY",
    dialCode: "+592",
    flag: "https://flagcdn.com/gy.svg",
  },
  {
    name: "Haiti",
    code: "HT",
    dialCode: "+509",
    flag: "https://flagcdn.com/ht.svg",
  },
  {
    name: "Honduras",
    code: "HN",
    dialCode: "+504",
    flag: "https://flagcdn.com/hn.svg",
  },
  {
    name: "Hungary",
    code: "HU",
    dialCode: "+36",
    flag: "https://flagcdn.com/hu.svg",
  },
  {
    name: "Iceland",
    code: "IS",
    dialCode: "+354",
    flag: "https://flagcdn.com/is.svg",
  },
  {
    name: "India",
    code: "IN",
    dialCode: "+91",
    flag: "https://flagcdn.com/in.svg",
  },
  {
    name: "Indonesia",
    code: "ID",
    dialCode: "+62",
    flag: "https://flagcdn.com/id.svg",
  },
  {
    name: "Iran",
    code: "IR",
    dialCode: "+98",
    flag: "https://flagcdn.com/ir.svg",
  },
  {
    name: "Iraq",
    code: "IQ",
    dialCode: "+964",
    flag: "https://flagcdn.com/iq.svg",
  },
  {
    name: "Ireland",
    code: "IE",
    dialCode: "+353",
    flag: "https://flagcdn.com/ie.svg",
  },
  {
    name: "Israel",
    code: "IL",
    dialCode: "+972",
    flag: "https://flagcdn.com/il.svg",
  },
  {
    name: "Italy",
    code: "IT",
    dialCode: "+39",
    flag: "https://flagcdn.com/it.svg",
  },
  {
    name: "Jamaica",
    code: "JM",
    dialCode: "+1-876",
    flag: "https://flagcdn.com/jm.svg",
  },
  {
    name: "Japan",
    code: "JP",
    dialCode: "+81",
    flag: "https://flagcdn.com/jp.svg",
  },
  {
    name: "Jordan",
    code: "JO",
    dialCode: "+962",
    flag: "https://flagcdn.com/jo.svg",
  },
  {
    name: "Kazakhstan",
    code: "KZ",
    dialCode: "+7",
    flag: "https://flagcdn.com/kz.svg",
  },
  {
    name: "Kenya",
    code: "KE",
    dialCode: "+254",
    flag: "https://flagcdn.com/ke.svg",
  },
  {
    name: "Kiribati",
    code: "KI",
    dialCode: "+686",
    flag: "https://flagcdn.com/ki.svg",
  },
  {
    name: "Kuwait",
    code: "KW",
    dialCode: "+965",
    flag: "https://flagcdn.com/kw.svg",
  },
  {
    name: "Kyrgyzstan",
    code: "KG",
    dialCode: "+996",
    flag: "https://flagcdn.com/kg.svg",
  },
  {
    name: "Laos",
    code: "LA",
    dialCode: "+856",
    flag: "https://flagcdn.com/la.svg",
  },
  {
    name: "Latvia",
    code: "LV",
    dialCode: "+371",
    flag: "https://flagcdn.com/lv.svg",
  },
  {
    name: "Lebanon",
    code: "LB",
    dialCode: "+961",
    flag: "https://flagcdn.com/lb.svg",
  },
  {
    name: "Lesotho",
    code: "LS",
    dialCode: "+266",
    flag: "https://flagcdn.com/ls.svg",
  },
  {
    name: "Liberia",
    code: "LR",
    dialCode: "+231",
    flag: "https://flagcdn.com/lr.svg",
  },
  {
    name: "Libya",
    code: "LY",
    dialCode: "+218",
    flag: "https://flagcdn.com/ly.svg",
  },
  {
    name: "Liechtenstein",
    code: "LI",
    dialCode: "+423",
    flag: "https://flagcdn.com/li.svg",
  },
  {
    name: "Lithuania",
    code: "LT",
    dialCode: "+370",
    flag: "https://flagcdn.com/lt.svg",
  },
  {
    name: "Luxembourg",
    code: "LU",
    dialCode: "+352",
    flag: "https://flagcdn.com/lu.svg",
  },
  {
    name: "Madagascar",
    code: "MG",
    dialCode: "+261",
    flag: "https://flagcdn.com/mg.svg",
  },
  {
    name: "Malawi",
    code: "MW",
    dialCode: "+265",
    flag: "https://flagcdn.com/mw.svg",
  },
  {
    name: "Malaysia",
    code: "MY",
    dialCode: "+60",
    flag: "https://flagcdn.com/my.svg",
  },
  {
    name: "Maldives",
    code: "MV",
    dialCode: "+960",
    flag: "https://flagcdn.com/mv.svg",
  },
  {
    name: "Mali",
    code: "ML",
    dialCode: "+223",
    flag: "https://flagcdn.com/ml.svg",
  },
  {
    name: "Malta",
    code: "MT",
    dialCode: "+356",
    flag: "https://flagcdn.com/mt.svg",
  },
  {
    name: "Marshall Islands",
    code: "MH",
    dialCode: "+692",
    flag: "https://flagcdn.com/mh.svg",
  },
  {
    name: "Mauritania",
    code: "MR",
    dialCode: "+222",
    flag: "https://flagcdn.com/mr.svg",
  },
  {
    name: "Mauritius",
    code: "MU",
    dialCode: "+230",
    flag: "https://flagcdn.com/mu.svg",
  },
  {
    name: "Mexico",
    code: "MX",
    dialCode: "+52",
    flag: "https://flagcdn.com/mx.svg",
  },
  {
    name: "Micronesia",
    code: "FM",
    dialCode: "+691",
    flag: "https://flagcdn.com/fm.svg",
  },
  {
    name: "Moldova",
    code: "MD",
    dialCode: "+373",
    flag: "https://flagcdn.com/md.svg",
  },
  {
    name: "Monaco",
    code: "MC",
    dialCode: "+377",
    flag: "https://flagcdn.com/mc.svg",
  },
  {
    name: "Mongolia",
    code: "MN",
    dialCode: "+976",
    flag: "https://flagcdn.com/mn.svg",
  },
  {
    name: "Montenegro",
    code: "ME",
    dialCode: "+382",
    flag: "https://flagcdn.com/me.svg",
  },
  {
    name: "Morocco",
    code: "MA",
    dialCode: "+212",
    flag: "https://flagcdn.com/ma.svg",
  },
  {
    name: "Mozambique",
    code: "MZ",
    dialCode: "+258",
    flag: "https://flagcdn.com/mz.svg",
  },
  {
    name: "Myanmar (Burma)",
    code: "MM",
    dialCode: "+95",
    flag: "https://flagcdn.com/mm.svg",
  },
  {
    name: "Namibia",
    code: "NA",
    dialCode: "+264",
    flag: "https://flagcdn.com/na.svg",
  },
  {
    name: "Nauru",
    code: "NR",
    dialCode: "+674",
    flag: "https://flagcdn.com/nr.svg",
  },
  {
    name: "Nepal",
    code: "NP",
    dialCode: "+977",
    flag: "https://flagcdn.com/np.svg",
  },
  {
    name: "Netherlands",
    code: "NL",
    dialCode: "+31",
    flag: "https://flagcdn.com/nl.svg",
  },
  {
    name: "New Zealand",
    code: "NZ",
    dialCode: "+64",
    flag: "https://flagcdn.com/nz.svg",
  },
  {
    name: "Nicaragua",
    code: "NI",
    dialCode: "+505",
    flag: "https://flagcdn.com/ni.svg",
  },
  {
    name: "Niger",
    code: "NE",
    dialCode: "+227",
    flag: "https://flagcdn.com/ne.svg",
  },
  {
    name: "Nigeria",
    code: "NG",
    dialCode: "+234",
    flag: "https://flagcdn.com/ng.svg",
  },
  {
    name: "North Korea",
    code: "KP",
    dialCode: "+850",
    flag: "https://flagcdn.com/kp.svg",
  },
  {
    name: "North Macedonia",
    code: "MK",
    dialCode: "+389",
    flag: "https://flagcdn.com/mk.svg",
  },
  {
    name: "Norway",
    code: "NO",
    dialCode: "+47",
    flag: "https://flagcdn.com/no.svg",
  },
  {
    name: "Oman",
    code: "OM",
    dialCode: "+968",
    flag: "https://flagcdn.com/om.svg",
  },
  {
    name: "Pakistan",
    code: "PK",
    dialCode: "+92",
    flag: "https://flagcdn.com/pk.svg",
  },
  {
    name: "Palau",
    code: "PW",
    dialCode: "+680",
    flag: "https://flagcdn.com/pw.svg",
  },
  {
    name: "Palestine",
    code: "PS",
    dialCode: "+970",
    flag: "https://flagcdn.com/ps.svg",
  },
  {
    name: "Panama",
    code: "PA",
    dialCode: "+507",
    flag: "https://flagcdn.com/pa.svg",
  },
  {
    name: "Papua New Guinea",
    code: "PG",
    dialCode: "+675",
    flag: "https://flagcdn.com/pg.svg",
  },
  {
    name: "Paraguay",
    code: "PY",
    dialCode: "+595",
    flag: "https://flagcdn.com/py.svg",
  },
  {
    name: "Peru",
    code: "PE",
    dialCode: "+51",
    flag: "https://flagcdn.com/pe.svg",
  },
  {
    name: "Philippines",
    code: "PH",
    dialCode: "+63",
    flag: "https://flagcdn.com/ph.svg",
  },
  {
    name: "Poland",
    code: "PL",
    dialCode: "+48",
    flag: "https://flagcdn.com/pl.svg",
  },
  {
    name: "Portugal",
    code: "PT",
    dialCode: "+351",
    flag: "https://flagcdn.com/pt.svg",
  },
  {
    name: "Qatar",
    code: "QA",
    dialCode: "+974",
    flag: "https://flagcdn.com/qa.svg",
  },
  {
    name: "Romania",
    code: "RO",
    dialCode: "+40",
    flag: "https://flagcdn.com/ro.svg",
  },
  {
    name: "Russia",
    code: "RU",
    dialCode: "+7",
    flag: "https://flagcdn.com/ru.svg",
  },
  {
    name: "Rwanda",
    code: "RW",
    dialCode: "+250",
    flag: "https://flagcdn.com/rw.svg",
  },
  {
    name: "Saint Kitts and Nevis",
    code: "KN",
    dialCode: "+1-869",
    flag: "https://flagcdn.com/kn.svg",
  },
  {
    name: "Saint Lucia",
    code: "LC",
    dialCode: "+1-758",
    flag: "https://flagcdn.com/lc.svg",
  },
  {
    name: "Saint Vincent and the Grenadines",
    code: "VC",
    dialCode: "+1-784",
    flag: "https://flagcdn.com/vc.svg",
  },
  {
    name: "Samoa",
    code: "WS",
    dialCode: "+685",
    flag: "https://flagcdn.com/ws.svg",
  },
  {
    name: "San Marino",
    code: "SM",
    dialCode: "+378",
    flag: "https://flagcdn.com/sm.svg",
  },
  {
    name: "Sao Tome and Principe",
    code: "ST",
    dialCode: "+239",
    flag: "https://flagcdn.com/st.svg",
  },
  {
    name: "Saudi Arabia",
    code: "SA",
    dialCode: "+966",
    flag: "https://flagcdn.com/sa.svg",
  },
  {
    name: "Senegal",
    code: "SN",
    dialCode: "+221",
    flag: "https://flagcdn.com/sn.svg",
  },
  {
    name: "Serbia",
    code: "RS",
    dialCode: "+381",
    flag: "https://flagcdn.com/rs.svg",
  },
  {
    name: "Seychelles",
    code: "SC",
    dialCode: "+248",
    flag: "https://flagcdn.com/sc.svg",
  },
  {
    name: "Sierra Leone",
    code: "SL",
    dialCode: "+232",
    flag: "https://flagcdn.com/sl.svg",
  },
  {
    name: "Singapore",
    code: "SG",
    dialCode: "+65",
    flag: "https://flagcdn.com/sg.svg",
  },
  {
    name: "Slovakia",
    code: "SK",
    dialCode: "+421",
    flag: "https://flagcdn.com/sk.svg",
  },
  {
    name: "Slovenia",
    code: "SI",
    dialCode: "+386",
    flag: "https://flagcdn.com/si.svg",
  },
  {
    name: "Solomon Islands",
    code: "SB",
    dialCode: "+677",
    flag: "https://flagcdn.com/sb.svg",
  },
  {
    name: "Somalia",
    code: "SO",
    dialCode: "+252",
    flag: "https://flagcdn.com/so.svg",
  },
  {
    name: "South Africa",
    code: "ZA",
    dialCode: "+27",
    flag: "https://flagcdn.com/za.svg",
  },
  {
    name: "South Korea",
    code: "KR",
    dialCode: "+82",
    flag: "https://flagcdn.com/kr.svg",
  },
  {
    name: "South Sudan",
    code: "SS",
    dialCode: "+211",
    flag: "https://flagcdn.com/ss.svg",
  },
  {
    name: "Spain",
    code: "ES",
    dialCode: "+34",
    flag: "https://flagcdn.com/es.svg",
  },
  {
    name: "Sri Lanka",
    code: "LK",
    dialCode: "+94",
    flag: "https://flagcdn.com/lk.svg",
  },
  {
    name: "Sudan",
    code: "SD",
    dialCode: "+249",
    flag: "https://flagcdn.com/sd.svg",
  },
  {
    name: "Suriname",
    code: "SR",
    dialCode: "+597",
    flag: "https://flagcdn.com/sr.svg",
  },
  {
    name: "Sweden",
    code: "SE",
    dialCode: "+46",
    flag: "https://flagcdn.com/se.svg",
  },
  {
    name: "Switzerland",
    code: "CH",
    dialCode: "+41",
    flag: "https://flagcdn.com/ch.svg",
  },
  {
    name: "Syria",
    code: "SY",
    dialCode: "+963",
    flag: "https://flagcdn.com/sy.svg",
  },
  {
    name: "Taiwan",
    code: "TW",
    dialCode: "+886",
    flag: "https://flagcdn.com/tw.svg",
  },
  {
    name: "Tajikistan",
    code: "TJ",
    dialCode: "+992",
    flag: "https://flagcdn.com/tj.svg",
  },
  {
    name: "Tanzania",
    code: "TZ",
    dialCode: "+255",
    flag: "https://flagcdn.com/tz.svg",
  },
  {
    name: "Thailand",
    code: "TH",
    dialCode: "+66",
    flag: "https://flagcdn.com/th.svg",
  },
  {
    name: "Timor-Leste",
    code: "TL",
    dialCode: "+670",
    flag: "https://flagcdn.com/tl.svg",
  },
  {
    name: "Togo",
    code: "TG",
    dialCode: "+228",
    flag: "https://flagcdn.com/tg.svg",
  },
  {
    name: "Tonga",
    code: "TO",
    dialCode: "+676",
    flag: "https://flagcdn.com/to.svg",
  },
  {
    name: "Trinidad and Tobago",
    code: "TT",
    dialCode: "+1-868",
    flag: "https://flagcdn.com/tt.svg",
  },
  {
    name: "Tunisia",
    code: "TN",
    dialCode: "+216",
    flag: "https://flagcdn.com/tn.svg",
  },
  {
    name: "Turkey",
    code: "TR",
    dialCode: "+90",
    flag: "https://flagcdn.com/tr.svg",
  },
  {
    name: "Turkmenistan",
    code: "TM",
    dialCode: "+993",
    flag: "https://flagcdn.com/tm.svg",
  },
  {
    name: "Tuvalu",
    code: "TV",
    dialCode: "+688",
    flag: "https://flagcdn.com/tv.svg",
  },
  {
    name: "Uganda",
    code: "UG",
    dialCode: "+256",
    flag: "https://flagcdn.com/ug.svg",
  },
  {
    name: "Ukraine",
    code: "UA",
    dialCode: "+380",
    flag: "https://flagcdn.com/ua.svg",
  },
  {
    name: "United Arab Emirates",
    code: "AE",
    dialCode: "+971",
    flag: "https://flagcdn.com/ae.svg",
  },
  {
    name: "United Kingdom",
    code: "GB",
    dialCode: "+44",
    flag: "https://flagcdn.com/gb.svg",
  },
  {
    name: "United States",
    code: "US",
    dialCode: "+1",
    flag: "https://flagcdn.com/us.svg",
  },
  {
    name: "Uruguay",
    code: "UY",
    dialCode: "+598",
    flag: "https://flagcdn.com/uy.svg",
  },
  {
    name: "Uzbekistan",
    code: "UZ",
    dialCode: "+998",
    flag: "https://flagcdn.com/uz.svg",
  },
  {
    name: "Vanuatu",
    code: "VU",
    dialCode: "+678",
    flag: "https://flagcdn.com/vu.svg",
  },
  {
    name: "Vatican City",
    code: "VA",
    dialCode: "+379",
    flag: "https://flagcdn.com/va.svg",
  },
  {
    name: "Venezuela",
    code: "VE",
    dialCode: "+58",
    flag: "https://flagcdn.com/ve.svg",
  },
  {
    name: "Vietnam",
    code: "VN",
    dialCode: "+84",
    flag: "https://flagcdn.com/vn.svg",
  },
  {
    name: "Yemen",
    code: "YE",
    dialCode: "+967",
    flag: "https://flagcdn.com/ye.svg",
  },
  {
    name: "Zambia",
    code: "ZM",
    dialCode: "+260",
    flag: "https://flagcdn.com/zm.svg",
  },
  {
    name: "Zimbabwe",
    code: "ZW",
    dialCode: "+263",
    flag: "https://flagcdn.com/zw.svg",
  },
  {
    name: "Bermuda",
    code: "BM",
    dialCode: "+1-441",
    flag: "https://flagcdn.com/bm.svg",
  },
  {
    name: "British Virgin Islands",
    code: "VG",
    dialCode: "+1-284",
    flag: "https://flagcdn.com/vg.svg",
  },
  {
    name: "Cayman Islands",
    code: "KY",
    dialCode: "+1-345",
    flag: "https://flagcdn.com/ky.svg",
  },
  {
    name: "Cook Islands",
    code: "CK",
    dialCode: "+682",
    flag: "https://flagcdn.com/ck.svg",
  },
  {
    name: "Curaçao",
    code: "CW",
    dialCode: "+599",
    flag: "https://flagcdn.com/cw.svg",
  },
  {
    name: "Falkland Islands",
    code: "FK",
    dialCode: "+500",
    flag: "https://flagcdn.com/fk.svg",
  },
  {
    name: "Faroe Islands",
    code: "FO",
    dialCode: "+298",
    flag: "https://flagcdn.com/fo.svg",
  },
  {
    name: "French Guiana",
    code: "GF",
    dialCode: "+594",
    flag: "https://flagcdn.com/gf.svg",
  },
  {
    name: "French Polynesia",
    code: "PF",
    dialCode: "+689",
    flag: "https://flagcdn.com/pf.svg",
  },
  {
    name: "Gibraltar",
    code: "GI",
    dialCode: "+350",
    flag: "https://flagcdn.com/gi.svg",
  },
  {
    name: "Greenland",
    code: "GL",
    dialCode: "+299",
    flag: "https://flagcdn.com/gl.svg",
  },
  {
    name: "Guadeloupe",
    code: "GP",
    dialCode: "+590",
    flag: "https://flagcdn.com/gp.svg",
  },
  {
    name: "Guam",
    code: "GU",
    dialCode: "+1-671",
    flag: "https://flagcdn.com/gu.svg",
  },
  {
    name: "Hong Kong",
    code: "HK",
    dialCode: "+852",
    flag: "https://flagcdn.com/hk.svg",
  },
  {
    name: "Isle of Man",
    code: "IM",
    dialCode: "+44",
    flag: "https://flagcdn.com/im.svg",
  },
  {
    name: "Jersey",
    code: "JE",
    dialCode: "+44",
    flag: "https://flagcdn.com/je.svg",
  },
  {
    name: "Macau",
    code: "MO",
    dialCode: "+853",
    flag: "https://flagcdn.com/mo.svg",
  },
  {
    name: "Martinique",
    code: "MQ",
    dialCode: "+596",
    flag: "https://flagcdn.com/mq.svg",
  },
  {
    name: "Mayotte",
    code: "YT",
    dialCode: "+262",
    flag: "https://flagcdn.com/yt.svg",
  },
  {
    name: "Montserrat",
    code: "MS",
    dialCode: "+1-664",
    flag: "https://flagcdn.com/ms.svg",
  },
  {
    name: "New Caledonia",
    code: "NC",
    dialCode: "+687",
    flag: "https://flagcdn.com/nc.svg",
  },
  {
    name: "Niue",
    code: "NU",
    dialCode: "+683",
    flag: "https://flagcdn.com/nu.svg",
  },
  {
    name: "Northern Mariana Islands",
    code: "MP",
    dialCode: "+1-670",
    flag: "https://flagcdn.com/mp.svg",
  },
  {
    name: "Puerto Rico",
    code: "PR",
    dialCode: "+1-787",
    flag: "https://flagcdn.com/pr.svg",
  },
  {
    name: "Réunion",
    code: "RE",
    dialCode: "+262",
    flag: "https://flagcdn.com/re.svg",
  },
  {
    name: "Saint Barthélemy",
    code: "BL",
    dialCode: "+590",
    flag: "https://flagcdn.com/bl.svg",
  },
  {
    name: "Saint Martin",
    code: "MF",
    dialCode: "+590",
    flag: "https://flagcdn.com/mf.svg",
  },
  {
    name: "Saint Pierre and Miquelon",
    code: "PM",
    dialCode: "+508",
    flag: "https://flagcdn.com/pm.svg",
  },
  {
    name: "Sint Maarten",
    code: "SX",
    dialCode: "+1-721",
    flag: "https://flagcdn.com/sx.svg",
  },
  {
    name: "Tokelau",
    code: "TK",
    dialCode: "+690",
    flag: "https://flagcdn.com/tk.svg",
  },
  {
    name: "Turks and Caicos Islands",
    code: "TC",
    dialCode: "+1-649",
    flag: "https://flagcdn.com/tc.svg",
  },
  {
    name: "U.S. Virgin Islands",
    code: "VI",
    dialCode: "+1-340",
    flag: "https://flagcdn.com/vi.svg",
  },
  {
    name: "Wallis and Futuna",
    code: "WF",
    dialCode: "+681",
    flag: "https://flagcdn.com/wf.svg",
  },
  {
    name: "Western Sahara",
    code: "EH",
    dialCode: "+212",
    flag: "https://flagcdn.com/eh.svg",
  },
];
export default Countries;
